var collectionBanners = {
    onInit: function(){
        const currentCollection = $("#collection-handle-helper").val();
        $(".grid__item.banner-item").each(function(){
            var bannerPosition = $(this).data('position');
            var relatedCollection = '';

            if($(this).find('.collection-related-block').length){
                relatedCollection = $(this).find('.collection-related-block').data('collections').split(',');
                if(relatedCollection.includes(currentCollection)){
                    collectionBanners.insertBanner($(this).clone(), bannerPosition);
                }
            }else{
                collectionBanners.insertBanner($(this).clone(), bannerPosition);
            }

        });
    },
    insertBanner: function(el, position){

        const qItems = $("#main-collection-product-grid li:not('.banner-item')").length;
        if (!window.matchMedia( "(min-width: 835px)" ).matches) {
            if((position % 2) === 0){
                position++;
            }
            el.css('height', $("#main-collection-product-grid li:not('.banner-item')").eq(0).height());
        }

        if(position <= qItems){
            el.show();
            $("#main-collection-product-grid li:not('.banner-item')").eq(position - 1).before(el);
        }

    }

};

collectionBanners.onInit();